export const roleConfiguration = [
  {
    key: "hub",
    title: "Content Hub",
    description: "Permissions to access, create, and edit the hub",
    icon: "paperflite-stream-access",
    options: [
      { key: "access", label: "Access", description: "Permission to access the hub" },
      { key: "create", label: "Create", description: "Permission to create a stream" },
      { key: "edit", label: "Edit", description: "Permission to edit hub layout" },
    ],
  },
  {
    key: "collection",
    title: "Collections",
    description: "Permissions to access, create, collaborate, and template collections",
    icon: "paperflite-collections",
    options: [
      { key: "access", label: "Access", description: "Permission to access collections" },
      { key: "create", label: "Create", description: "Permission to create a collection" },
      { key: "collaborate", label: "Collaborate", description: "Permission to collaborate a collection" },
      { key: "template", label: "Mark as Template", description: "Permission to mark a collection as a template" },
    ],
  },
  {
    key: "conversation",
    title: "Conversations",
    description: "Permissions to access conversations",
    icon: "paperflite-conversations",
    options: [{ key: "access", label: "Access", description: "Permission to access conversations" }],
  },
  {
    key: "dealRoom",
    title: "Deal Room",
    description: "Permissions to access, create, and collaborate on deal rooms",
    icon: "paperflite-deal-room",
    options: [
      { key: "access", label: "Access", description: "Permission to access deal rooms" },
      { key: "create", label: "Create", description: "Permission to create a deal room" },
      { key: "collaborate", label: "Collaborate", description: "Permission to collaborate a deal room" },
    ],
  },
  {
    key: "engage",
    title: "Engage",
    description: "Permissions to access and manage engagement with recipients",
    icon: "paperflite-engage-1",
    options: [
      { key: "access", label: "Access", description: "Permission to access the 'Engage' module and interact with recipients" },
      { key: "block", label: "Access all recpients" , description: "Permission to view interactions with all recipients of your Organization" },
      { key: "viewOnly", label: "View Only", description: "View only access to prior interactions with the user's direct recipients" },
      { key: "globalEngage", label: "Block recipients", description: "Block select recipients from interacting with your organization"},
    ],
  },
  {
    key: "contact",
    title: "Contacts",
    description: "Permissions to access and create contacts",
    icon: "paperflite-group",
    options: [
      { key: "access", label: "Access", description: "Permission to access contacts" },
      { key: "create", label: "Create", description: "Permission to create a contact" },
    ],
  },
  {
    key: "report",
    title: "Reports",
    description: "Permissions to access, download, and restrict reports",
    icon: "paperflite-reports",
    options: [
      { key: "access", label: "Access", description: "Permission to access reports" },
      { key: "download", label: "Download", description: "Permission to download reports" },
      { key: "restricted", label: "Restricted", description: "Restrict to access reports only of user groups the user is part of" },
    ],
  },
  {
    key: "share",
    title: "Share",
    description: "Permissions to access and manage share options",
    icon: "paperflite-send",
    options: [{ key: "access", label: "Access", description: "Permission to access share" }],
  },
  {
    key: "asset",
    title: "Assets",
    description: "Permissions to download and create assets",
    icon:"paperflite-multiple-documents",
    options: [
      { key: "download", label: "Download", description: "Permission to download" },
      { key: "create", label: "Create", description: "Permission to create asset" },
    ],
  },
  {
    key: "search",
    title: "Search",
    description: "Permissions to access search functionality",
    icon:"paperflite-search-icon",
    options: [{ key: "access", label: "Access", description: "Permission to access search" }],
  },
  {
    key: "settingsManagement",
    title: "Settings Management",
    description: "Permissions to manage account, users, templates, and integrations",
    icon: "paperflite-settings",
    options: [
      { key: "userManagement", label: "User Management", description: "Permission to access User Management" },
      { key: "accountManagement", label: "Account Management", description: "Permission to access Account Management" },
      { key: "datasourceManagement", label: "Content Sources", description: "Permission to access Content Sources" },
      { key: "integrations", label: "Integrations" , description: "Permission to access integrations" },
      { key: "customFields", label: "Custom Fields" , description: "Permission to access Custom Fields" },
      { key: "emailTemplates", label: "Email Templates" , description: "Permission to access Email Templates" },
      { key: "notifications", label: "Notifications" , description: "Permission to access Notifications" },
      { key: "ndaTemplates", label: "NDA Templates" , description: "Permission to access NDA Templates" },
      { key: "privacyPolicyControl", label: "Privacy Policy" , description: "Permission to access Privacy Policy Control" },
    ],
  },
];

export enum NonEditableRole {
  Administrator = "Administrator",
  NormalUser = "Normal User",
  BIAnalyst = "BI Analyst",
  ContentPublisher = "Content Publisher",
}

export const isRoleDisabled = (roleId: string | null, roleName?: string | null,  description?: string | null): boolean => {
  if (!roleId) return false;
  if (!roleName || description == null) return false;

  return (
    Object.values(NonEditableRole).includes(roleName as NonEditableRole) &&
    roleId !== "new-role-temp-id"
  );
};


